<template>
  <div class="herosection">
    <div class="wrapper">
      <div class="container-fluid">
        <div class="row">
          <!-- left -->
          <div class="col-lg-12 px-0 d-flex flex-column align-items-center">
            <!-- <div>
              <span
                class="badge rounded-pill text-bg-light bg-white herosection__jobs d-inline-flex"
              >
                <svg
                  class="me-2"
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                >
                  <g clip-path="url(#clip0_888_15533)">
                    <path
                      d="M12.6667 2.66667H11.9333C11.7786 1.91428 11.3692 1.23823 10.7742 0.752479C10.1791 0.266727 9.4348 0.000969683 8.66667 0L7.33333 0C6.5652 0.000969683 5.82088 0.266727 5.22583 0.752479C4.63079 1.23823 4.2214 1.91428 4.06667 2.66667H3.33333C2.4496 2.66773 1.60237 3.01925 0.97748 3.64415C0.352588 4.26904 0.00105857 5.11627 0 6L0 8H16V6C15.9989 5.11627 15.6474 4.26904 15.0225 3.64415C14.3976 3.01925 13.5504 2.66773 12.6667 2.66667ZM5.456 2.66667C5.59339 2.27806 5.84749 1.94139 6.18353 1.70273C6.51958 1.46406 6.92116 1.33504 7.33333 1.33333H8.66667C9.07884 1.33504 9.48042 1.46406 9.81647 1.70273C10.1525 1.94139 10.4066 2.27806 10.544 2.66667H5.456Z"
                      fill="#0060AF"
                    />
                    <path
                      d="M8.66667 9.9987C8.66667 10.1755 8.59643 10.3451 8.47141 10.4701C8.34638 10.5951 8.17681 10.6654 8 10.6654C7.82319 10.6654 7.65362 10.5951 7.5286 10.4701C7.40357 10.3451 7.33333 10.1755 7.33333 9.9987V9.33203H0V12.6654C0.00105857 13.5491 0.352588 14.3963 0.97748 15.0212C1.60237 15.6461 2.4496 15.9976 3.33333 15.9987H12.6667C13.5504 15.9976 14.3976 15.6461 15.0225 15.0212C15.6474 14.3963 15.9989 13.5491 16 12.6654V9.33203H8.66667V9.9987Z"
                      fill="#0060AF"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_888_15533">
                      <rect width="16" height="16" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
                Jobs</span
              >
            </div> -->

            <h2
              class="herosection__title flex justify-content-center text-center"
            >
              Empower Your Career <br />
              <span class="text-highlight"> Journey with Us</span>
            </h2>

            <p class="herosection__queries">
              For any immediate queries, please contact our HR team:
            </p>
            <p class="herosection__email">hr@mediusware.com</p>

            <div class="">
              <!-- <div>
                <button
                  class="hire-developer-black-btn-new d-flex align-items-center position-relative"
                  @click="scrollToCareerSection"
                >
                  <div class="text-white"></div>
                  <div class="d-flex align-items-center my-auto">
                    <h6 class="text-title ms-2 mt-1 text-white">
                      Explore Open Positions
                    </h6>
                  </div>
                </button>
              </div> -->

              <div class="d-flex justify-content-center">
                <button
                  @click="scrollToCareerSection"
                  class="cta-button-white position-relative overflow-hidden d-inline-flex align-items-center px-3 py-2 rounded-pill border border-primary bg-transparent text-primary text-decoration-none"
                >
                  <span
                    class="z-1 d-flex align-items-center gap-2 text-nowrap fw-medium"
                  >
                    Explore Open Positions
                    <i class="fas fa-arrow-right icon-transition-white"></i>
                  </span>

                  <!-- Background Animation -->
                  <div class="cta-bg-white"></div>
                </button>
              </div>
            </div>
          </div>

          <div
            class="statistics-small-card container d-flex justify-content-center align-items-center position-relative mt-5"
          >
            <div
              class="stats-box text-white rounded-4 px-4 py-2 d-flex flex-column flex-sm-row align-items-center justify-content-between gap-3"
            >
              <!-- Client Avatars -->
              <div class="ml-5">
                <a
                  href="https://mediusware.com/testimonial"
                  class="d-flex align-items-center avatar-group"
                >
                  <div
                    v-for="(item, index) in clientImages"
                    :key="index"
                    class="avatar border border-white rounded-circle d-flex align-items-center justify-content-center shadow-sm bg-light"
                  >
                    <img
                      :src="item"
                      alt="client"
                      class="img-fluid rounded-circle avatar-img"
                    />
                  </div>
                </a>
              </div>

              <!-- Stats Section -->
              <div
                class="stats-container d-flex flex-wrap flex-sm-nowrap align-items-center justify-content-center gap-3 w-100 w-sm-auto"
              >
                <div
                  v-for="(item, index) in statCardData"
                  :key="item.id"
                  class="d-flex align-items-center position-relative stat-item"
                >
                  <a
                    v-if="item.link"
                    :href="item.link"
                    :target="item.isOpenNewTab ? '_blank' : '_self'"
                    rel="noopener noreferrer"
                    class="p-2 text-decoration-none text-white hover-scale w-100 d-inline-block position-relative"
                  >
                    <component
                      :is="getComponentType(item.component)"
                      :value="item.value"
                      :title="item.title"
                      :has-link="item.hasLink"
                    />
                    <!-- 🔹 Hover Arrow Icon -->
                    <i
                      class="fas fa-arrow-right icon-transition hover-arrow"
                    ></i>
                  </a>

                  <div v-else class="p-2 hover-scale position-relative w-100">
                    <component
                      :is="getComponentType(item.component)"
                      :value="item.value"
                      :title="item.title"
                      :has-link="item.hasLink"
                    />
                    <!-- 🔹 Hover Arrow Icon -->
                    <i
                      class="fas fa-arrow-right icon-transition hover-arrow"
                    ></i>
                  </div>

                  <div
                    v-if="
                      item.haveRightBorder && index !== statCardData.length - 1
                    "
                    class="d-none d-sm-block border-end border-light opacity-25 mx-3"
                    style="height: 40px"
                  ></div>
                </div>
              </div>
            </div>
          </div>

          <!-- right -->
          <!-- <div class="col-lg-6 px-0">
            <div class="relative">
              <lottie-vue-player
                id="herosection-lottie"
                :src="JSON.stringify(lottie_json)"
                :autoplay="true"
                :loop="true"
              >
              </lottie-vue-player>
            </div>
          </div> -->
        </div>
      </div>
    </div>

    <!-- <img
      id="herosection__overlay_first"
      src="/assets/overlay-1.svg"
      alt=""
      height="{500}"
      width="{1280}"
    /> -->
    <!-- <img
      id="herosection__overlay_second"
      className="absolute top-0 right-0 z-[-1] herosection__overlay"
      src="/assets/overlay-2.svg"
      alt=""
      height="{200}"
      width="{580}"
    /> -->

    <!-- <img
      id="herosection__overlay_second"
      className="absolute top-0 bottom-0 right-0 z-[-1] herosection__overlay"
      src="/assets/Career.jpg"
      alt=""
      height="{200}"
      width="{580}"
    /> -->
  </div>
</template>
<script>
import Animationlayer from "../../public/lottiefiles/herosection.json";
import cl1 from "../../public/assets/client-image/cl1.png";
import cl2 from "../../public/assets/client-image/cl2.png";
import cl3 from "../../public/assets/client-image/cl3.png";
import Experience from "./Experience.vue";
import Clutch from "./Clutch.vue";
import TrustPilot from "./TrustPilot.vue";
import Behance from "./Behance.vue";

export default {
  name: "StatisticsSmallCard",
  components: { Experience, Clutch, TrustPilot, Behance },
  data() {
    return {
      lottie_json: Animationlayer,
      clientImages: [cl1, cl2, cl3],
      statCardData: [
        {
          id: 1,
          name: "Happy Clients",
          value: "750",
          title: "Happy Clients",
          hasLink: true,
          link: "https://mediusware.com/testimonial",
          isOpenNewTab: false,
          haveRightBorder: true,
        },
        {
          id: 2,
          name: "Engineers",
          value: "120",
          title: "Engineers",
          hasLink: true,
          link: "https://mediusware.com/team",
          isOpenNewTab: false,
          haveRightBorder: true,
        },
        {
          id: 3,
          name: "Projects",
          value: "850",
          title: "Projects",
          hasLink: true,
          link: "https://mediusware.com/case-study",
          isOpenNewTab: false,
          haveRightBorder: true,
        },
        {
          id: 4,
          name: "Clutch",
          component: "Clutch",
          title: "Clutch",
          hasLink: false,
          link: "https://clutch.co/profile/mediusware",
          isOpenNewTab: true,
          haveRightBorder: true,
        },
        {
          id: 5,
          name: "TrustPilot",
          component: "TrustPilot",
          title: "TrustPilot",
          hasLink: false,
          link: "https://www.trustpilot.com/review/mediusware.com",
          isOpenNewTab: true,
          haveRightBorder: true,
        },
        {
          id: 6,
          name: "Behance",
          component: "Behance",
          title: "Behance",
          hasLink: false,
          link: "https://www.behance.net/mediusware",
          isOpenNewTab: true,
          haveRightBorder: false,
        },
      ],
    };
  },
  methods: {
    scrollToCareerSection() {
      const el = document.getElementById("careerSection");
      if (el) el.scrollIntoView({ behavior: "smooth" });
    },
    getComponentType(type) {
      switch (type) {
        case "Clutch":
          return "Clutch";
        case "TrustPilot":
          return "TrustPilot";
        case "Behance":
          return "Behance";
        default:
          return "Experience";
      }
    },
  },
};
</script>

<style scoped lang="scss">
.text-highlight {
  color: #00a88e;
}

.herosection {
  //background: #e6eff7 !important;
  position: relative;
  overflow: hidden;
  z-index: 1;

  #herosection-lottie {
    // background: #e6eff7 !important;
  }

  .herosection__jobs {
    background: #00a88e;
    color: #0060af !important;
    font-size: 14px;
    line-height: 16px;
    padding: 8px 16px;
    margin-bottom: 16px;
    font-weight: 500;
    p {
      font-size: 14px;
    }
  }

  .herosection__title {
    // font-weight: 900;
    margin-bottom: 32px;
    color: #002b4f;
    font-size: 52px;
    line-height: 70px;
    letter-spacing: -1px;

    @media screen and (max-width: "991px") {
      font-size: 32px;
      line-height: 44px;
    }
  }

  .herosection__queries {
    font-size: 18px;
    font-weight: 300;
    line-height: 19px;
    margin-bottom: 0.5rem;
    color: #123755;

    @media screen and (max-width: "991px") {
      font-size: 16px;
    }
  }
  .herosection__email {
    font-size: 20px;
    font-weight: 500;
    line-height: 19px;
    margin-bottom: 48px;
    color: #344054;

    @media screen and (max-width: "991px") {
      font-size: 16px;
      font-weight: 700;
    }
  }

  #herosection__overlay_first {
    position: absolute;
    top: 0;
    bottom: 0;
    z-index: -1;
    opacity: 0.05;
  }

  #herosection__overlay_second {
    position: absolute;
    top: 0;
    bottom: 0;
    z-index: -1;
    right: 0;
    left: 0;
    height: 100%;
    width: 100%;
    object-fit: cover;
  }
}

.book-a-call {
  padding: 16px 32px;
  font-size: 18px;

  @media screen and (max-width: "991px") {
    font-size: 16px;
    padding: 12px 8px;
  }
}

.wrapper {
  padding: 3rem 0;
}

@media screen and (max-width: "991px") {
  .wrapper {
    padding: 2rem 0;
    text-align: center;
  }

  .herosection__title {
    font-size: 34px;
    line-height: 50px;
  }
}
.hire-developer-black-btn-new {
  display: flex;
  padding: 12px 16px;
  justify-content: center;
  align-items: center;
  border-radius: 999px;
  background: #0060af;
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
}

.hire-developer-black-btn-new:hover {
  transition: ease-in-out 0.5s;
  background: #0967b4;
}

.stats-box {
  background-color: rgb(9 30 66);
}

.avatar-group .avatar {
  width: 50px;
  height: 50px;
  position: relative;
  z-index: 2;
}

.avatar-group .avatar-img {
  width: 40px;
  height: 40px;
  object-fit: contain;
}

.avatar-group .avatar:not(:first-child) {
  margin-left: -10px;
}

.hover-scale {
  transition: transform 0.3s ease-in-out;
}

.hover-scale:hover {
  transform: scale(1.05);
}

.stat-item {
  position: relative;
  overflow: visible;
}

.hover-arrow {
  position: absolute;
  bottom: -6px; /* slightly outside bottom */
  right: 0px; /* offset for subtle corner effect */
  color: #ebe2e2;
  font-size: 0.65rem;
  opacity: 0;
  transform: translateX(-10px);
  transition: all 0.55s ease;
  pointer-events: none;
}

.stat-item:hover .hover-arrow {
  opacity: 0.8;
  transform: translateX(0);
  transform: rotate(-45deg);
}

/* White background variant */
.cta-button-white {
  position: relative;
  transition: color 0.3s ease;
}

.cta-button-white .cta-bg-white {
  position: absolute;
  inset: 0;
  background: var(--primary, #0060AF);
  border-radius: 50rem;
  transform: scaleX(0);
  transform-origin: left;
  transition: transform 0.5s ease-out;
  z-index: 0;
}

.cta-button-white:hover .cta-bg-white {
  transform: scaleX(1);
}

.cta-button-white:hover span {
  color: #fff;
}

.icon-transition-white {
  transition: all 0.5s ease-out;
  transform: rotate(-45deg);
  color: var(--primary, #0060AF);
}

.cta-button-white:hover .icon-transition-white {
  transform: rotate(0deg);
  color: #fff;
}

</style>
